import { useState } from "react";
import BackToHomeBtn from "../../components/BackToHomeBtn";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import emergancyRequest from "../../services/emergancyRequest";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { loaderActions } from "../../redux/slices/loadingSlice";
import saveNewMidocoTask from "../../services/saveNewMidocoTask";

const SaveNewMidocoTask = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const booking = useAppSelector((state) => state.booking);
  const [bookingNumber, setBookingNumber] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");

  const submitHandler = async (e: any) => {
    e.preventDefault();
    dispatch(loaderActions.showLoader());
    const reqBody = {
      bookingNumber: bookingNumber,
      name: username,
      email: email,
      problem: description,
    };

    try {
      const response = await saveNewMidocoTask(reqBody);

      if (response.success) {
        toast.success("Ihre Anfrage wurde übermittelt, wir werden uns in Kürze bei Ihnen melden");
      } else {
        toast.error(
          "Ihre Anfrage wurde nicht übermittelt. Bitte versuchen Sie es später noch einmal"
        );
      }

      dispatch(loaderActions.hideLoader());
    } catch (ex: any) {
      toast.error("send fail");
      dispatch(loaderActions.hideLoader());
    }
  };

  return (
    <div className="py-2">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-6">
            <form className="bg-white p-3 rounded border" onSubmit={submitHandler}>
              <div className="mb-3">
                <label className="form-label">Buchungsnummer*</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(e: any) => setBookingNumber(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Name*</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(e: any) => setUsername(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Email Address*</label>
                <input
                  type="email"
                  className="form-control"
                  onChange={(e: any) => setEmail(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Message*</label>
                <textarea
                  className="form-control"
                  rows={4}
                  onChange={(e: any) => setDescription(e.target.value)}
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn-warning w-100 text-white">
                Ihre Anfrage absenden
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveNewMidocoTask;
